import PAGOS from '@/graphql/querys/administracion/pagos/pagos.gql';

export default {

  methods: {
    getPagosElemento(idElemento, fecha) {
      // Obtiene pagos de un elemento retorna total y fecha, referencia
      const pagosElemento = this.getListaPagos
        .filter((pago) => pago.id === idElemento)
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
        .filter((p) => p.fecha <= fecha);
      const detallePago = pagosElemento.map((p) => p.detallePago).join('-');
      const fechaUltima = pagosElemento.map((f) => f.fecha)
        .slice()
        .sort((a, b) => new Date(b) - new Date(a))
        .slice(-1)
        .pop();
      return {
        total: this.$ObjSumar(pagosElemento, 'total'),
        detalle: detallePago,
        fecha: new Date(fechaUltima).toLocaleDateString(),
      };
    },
  },
  apollo: {
    pagos: {
      query: PAGOS,
    },
  },
  computed: {
    getPagos() {
      if (!this.pagos) return [];
      return this.pagos;
    },
    getListaPagos() {
      const pagosLista = this.getPagos
        .map((pago) => ({
          detalle: pago.detalles.map((det) => ({
            ...det.pagoSolicitudDetalle,
            fecha: pago.fecha,
            referencia: pago.referencia,
          })),

        }))
        .flat()
        .map((pago) => pago.detalle.map((p) => {
          if (p.estimacion) {
            return {
              tipo: 'estimacion',
              id: p.estimacion.id,
              total: p.estimacion.totalFactura,
              fecha: p.fecha,
              detallePago: `[${p.referencia} / ${p.fecha}]`,
            };
          }
          if (p.anticipo) {
            return {
              tipo: 'anticipo',
              id: p.anticipo.id,
              total: p.anticipo.total,
              fecha: p.fecha,
              detallePago: `[${p.referencia} / ${p.fecha}]`,
            };
          }
          if (p.escalatoria) {
            return {
              tipo: 'escalatoria',
              id: p.escalatoria.id,
              total: p.escalatoria.total,
              fecha: p.fecha,
              detallePago: `[${p.referencia} / ${p.fecha}]`,
            };
          }
          if (p.gasto) {
            return {
              tipo: 'gasto',
              id: p.gasto.id,
              total: p.gasto.total,
              fecha: p.fecha,
              detallePago: `[${p.referencia} / ${p.fecha}]`,
            };
          }
          return false;
        }))
        .flat();

      return pagosLista;
    },

  },

};
